<template>
  <div>
    <!-- <h2 style="text-align: center; padding-bottom: 20px">
      {{ this.TitleExam }}
    </h2> -->
    <div style="display: flex; padding: 20px 0">
          <div style="padding-left: 17%; font-size: 18px;">
            <span style="font-weight: bold">主办单位：</span>
            <span style="width: 300px;display: inline-block;">{{ExamDetail.deptName}}</span>
          </div>
          <div style="padding-left: 1%; font-size: 18px;">
            <span style="font-weight: bold">考试科目：</span>
            <span style="width: 200px;display: inline-block;">{{ExamDetail.subjectName}}</span>
          </div>
          <div style="padding-left: 1%; font-size: 18px;">
             <span style="font-weight: bold">姓名：</span>
            <span style="width: 160px;display: inline-block;">{{userName}}</span>
          </div>
        </div>
        <div
          class="test-description"
          v-if="ExamDetail.description"
        ><span style="font-weight: bold">考试说明：</span>{{ ExamDetail.description }}</div>


    <div style="display: flex;margin-top:50px" id="pdfDom">
      <!-- 答题卡区域 -->
      <div class="leftPreview">
        <el-scrollbar style="height: 100%">
          <div style="width: 250px">
            <div class="title2">
              <i class="el-icon-date"></i>&nbsp;&nbsp;答题卡
            </div>
            <div class="leftimg" v-if="abc == ''">
              <img src="@/assets/images/暂无数据.png" />
              <br />
              <span style="color: #b2b8bd; margin-left: 4px">暂无数据</span>
            </div>
            <div class="leftdiv" v-if="examList !== ''">
              <span class="allscore-text">总分：{{ allScore }}</span>
            </div>
            <div class="nr" v-if="dxt != 0">
              <span style="padding-left: 22px">单选题</span>
              <span style="padding-left: 10px"
                >(共{{ dxt }}题，合计{{ dxtSum }}分)</span
              >
            </div>
            <div class="leftdiv" v-if="dxt != 0">
              <div style="display: flex; flex-wrap: wrap">
                <div
                  v-for="(item, index1) in abc"
                  :key="index1"
                  @click="jump(item.Id)"
                  v-if="item.Type == 1"
                >
                  <div
                    :class="['top',item.MyCate?(item.IsRight ? 'top-true':'top-false'):'top']"
                  >
                    <span
                      style=" font-size: 14px; color: white"
                      >{{ index1 + 1 }}</span
                    >
                  </div>
                  <div class="bottom">
                    <svg
                      v-if="item.RightNum == true"
                      class="icon"
                      style="margin-left: 5px"
                    >
                      <use xlink:href="#iconbiaoji" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div class="nr" v-if="ddxt != 0">
              <span style="padding-left: 22px">多选题</span>
              <span style="padding-left: 10px"
                >(共{{ ddxt }}题，合计{{ ddxtSum }}分)</span
              >
            </div>
            <div class="leftdiv" v-if="ddxt != 0">
              <div style="display: flex; flex-wrap: wrap">
                <div
                  v-for="(item, index2) in abc"
                  :key="index2"
                  @click="jump(item.Id)"
                  v-if="item.Type == 2"
                >
                  <div
                   :class="['top',item.MyCate?(item.IsRight ? 'top-true':'top-false'):'top']"
                  >
                    <span
                      style=" font-size: 14px; color: white"
                      >{{ index2 + 1 }}</span
                    >
                  </div>
                  <div class="bottom">
                    <svg
                      v-if="item.RightNum == true"
                      class="icon"
                      style="margin-left: 5px"
                    >
                      <use xlink:href="#iconbiaoji" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div class="nr" v-if="pdt != 0">
              <span style="padding-left: 22px">判断题</span>
              <span style="padding-left: 10px"
                >(共{{ pdt }}题，合计{{ pdtSum }}分)</span
              >
            </div>
            <div class="leftdiv" v-if="pdt != 0">
              <div style="display: flex; flex-wrap: wrap">
                <div
                  v-for="(item, index3) in abc"
                  :key="index3 + 'g8'"
                  @click="jump(item.Id)"
                  v-if="item.Type == 3"
                >
                  <div
                   :class="['top',item.MyCate?(item.IsRight ? 'top-true':'top-false'):'top']"
                  >
                    <span
                      style=" font-size: 14px; color: white"
                      >{{ index3 + 1 }}</span
                    >
                  </div>
                  <div class="bottom">
                    <svg
                      v-if="item.RightNum == true"
                      class="icon"
                      style="margin-left: 5px"
                    >
                      <use xlink:href="#iconbiaoji" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div class="nr" v-if="tkt != 0">
              <span style="padding-left: 22px">填空题</span>
              <span style="padding-left: 10px"
                >(共{{ tkt }}题，合计{{ tktSum }}分)</span
              >
            </div>
            <div class="leftdiv" v-if="tkt != 0">
              <div style="display: flex; flex-wrap: wrap">
                <div
                  v-for="(item, index5) in abc"
                  :key="index5 + 'g4'"
                  @click="jump(item.Id)"
                  v-if="item.Type == 4"
                >
                  <div
                    :class="['top',item.MyCate?(item.IsRight ? 'top-true':'top-false'):'top']"
                  >
                    <span
                      style=" font-size: 14px; color: white"
                      >{{ index5 + 1 }}</span
                    >
                  </div>
                  <div class="bottom">
                    <svg
                      v-if="item.RightNum == true"
                      class="icon"
                      style="margin-left: 5px"
                    >
                      <use xlink:href="#iconbiaoji" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div class="nr" v-if="wdt != 0">
              <span style="padding-left: 22px">问答题</span>
              <span style="padding-left: 10px"
                >(共{{ wdt }}题，合计{{ wdtSum }}分)</span
              >
            </div>
            <div class="leftdiv" v-if="wdt != 0">
              <div style="display: flex; flex-wrap: wrap">
                <div
                  v-for="(item, index4) in abc"
                  :key="index4 + 'g2'"
                  @click="jump(item.Id)"
                  v-if="item.Type == 5"
                >
                  <div
                   :class="['top',item.mycate?(item.IsRight ? 'top-true':'top-false'):'top']"
                  >
                    <span
                      style=" font-size: 14px; color: white"
                      >{{ index4 + 1 }}</span
                    >
                  </div>
                  <div class="bottom">
                    <svg
                      v-if="item.RightNum == true"
                      class="icon"
                      style="margin-left: 5px"
                    >
                      <use xlink:href="#iconbiaoji" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div class="nr" v-if="sct != 0">
              <span style="padding-left: 22px">实操题</span
              ><span style="padding-left: 10px"
                >(共{{ sct }}题，合计{{ sctSum }}分)</span
              >
            </div>
            <div class="leftdiv" v-if="sct != 0">
              <div style="display: flex; flex-wrap: wrap">
                <div
                  v-for="(item, index6) in abc"
                  :key="index6 + 'g1'"
                  @click="jump(item.Id)"
                  v-if="item.Type == 6"
                >
                  <div
                    :class="['top',item.mycate?(item.IsRight ? 'top-true':'top-false'):'top']"
                  >
                    <span
                      style=" font-size: 14px; color: white"
                      >{{ index6 + 1 }}</span
                    >
                  </div>
                  <div class="bottom">
                    <svg
                      v-if="item.RightNum == true"
                      class="icon"
                      style="margin-left: 5px"
                    >
                      <use xlink:href="#iconbiaoji" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-scrollbar>
      </div>
      <!-- 题目区域 -->
      <div class="zhuti">
        <div class="titles" v-if="dxt != 0">
          <span style="padding-left: 30px">单选题</span>
          <span style="padding-left: 10px"
            >(共 {{ dxt }} 题，合计 {{ dxtSum }} 分)</span
          >
        </div>
        <div
          v-for="(item, index) in abc"
          :key="index + 'f9'"
          v-if="item.Type == 1"
        >
          <div class="hhh">
            <div class="sss">
              <div class="subject">
                <span >{{ index + 1 }}.</span>
                
                <span style="flex:1" v-html="item.Title" :id="item.Id"></span>
              </div>
              <div>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="取消标记"
                  placement="top"
                >
                  <svg
                    v-if="item.bjStatus == true"
                    class="icon"
                    @click="biaoji(item, index)"
                  >
                    <use xlink:href="#iconbiaoji" />
                  </svg>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="标记"
                  placement="top"
                >
                  <svg
                    v-if="item.bjStatus == false"
                    class="icon"
                    @click="biaoji(item, index)"
                  >
                    <use xlink:href="#iconmark" />
                  </svg>
                </el-tooltip>
              </div>
            </div>
            <div class="select-box">
              <ul>
                <li
                  v-for="(items, indexs) in item.Answer"
                  :key="indexs + 'f8'"
                  :id="items.Name"
                >
                  <label :for="items.Id" style="margin-left: -40px">
                    <input type="radio" :checked="items.IsCheck" disabled />
                    {{ String.fromCharCode(64 + parseInt(indexs + 1)) }}.
                    {{ items.Name }}
                  </label>
                </li>
              </ul>
            </div>
            <!-- {{item.Answer[index]}} -->
            <!-- {{index}} -->
            <!-- v-if="item.Answer[index]" -->
            <div class="correct" >

             <span v-if="item.MyCate == false" ><i
                  class="el-icon-warning"
                  style="color: #e6a23c; width: 25px;font-size:18px"
                ></i
                >未作答</span>

             <span v-else>
                <span v-if="item.IsRight==true">
                <i
                  class="el-icon-success"
                  style="color: #67c23a;width: 25px;font-size:18px"
                ></i>
                答对了
              </span>
              <span v-else-if="item.IsRight==false">
                 <i
                  class="el-icon-error"
                  style="color: #f56c6c; width: 25px;font-size:18px"
                ></i>
                
                答错了
              </span>
             </span>

              
            </div>
            <div class="answer">
              <div
                v-for="(items, indexs) in item.Answer"
                :key="indexs + 'f7'"
                :id="items.Name"
              >
                <span v-if="indexs == 0 && items.IsRight == true"
                  >正确答案：A</span
                >
                <span v-if="indexs == 1 && items.IsRight == true"
                  >正确答案：B</span
                >
                <span v-if="indexs == 2 && items.IsRight == true"
                  >正确答案：C</span
                >
                <span v-if="indexs == 3 && items.IsRight == true"
                  >正确答案：D</span
                >
                <span v-if="indexs == 4 && items.IsRight == true"
                  >正确答案：E</span
                >
                <span v-if="indexs == 5 && items.IsRight == true"
                  >正确答案：F</span
                >
                <span v-if="indexs == 6 && items.IsRight == true"
                  >正确答案：G</span
                >
                <span v-if="indexs == 7 && items.IsRight == true"
                  >正确答案：H</span
                >
              </div>
              <div
                style="margin-left: 40px"
                v-for="(items, indexs12) in item.Answer"
                :key="indexs12 + 'f6'"
                :id="items.Name"
              >
                <span v-if="indexs12 == 0 && items.IsCheck == true"
                  >选择的答案：A</span
                >
                <span v-if="indexs12 == 1 && items.IsCheck == true"
                  >选择的答案：B</span
                >
                <span v-if="indexs12 == 2 && items.IsCheck == true"
                  >选择的答案：C</span
                >
                <span v-if="indexs12 == 3 && items.IsCheck == true"
                  >选择的答案：D</span
                >
                <span v-if="indexs12 == 4 && items.IsCheck == true"
                  >选择的答案：E</span
                >
                <span v-if="indexs12 == 5 && items.IsCheck == true"
                  >选择的答案：F</span
                >
                <span v-if="indexs12 == 6 && items.IsCheck == true"
                  >选择的答案：G</span
                >
                <span v-if="indexs12 == 7 && items.IsCheck == true"
                  >选择的答案：H</span
                >
              </div>
              <div style="margin-left: 40px">
                <span v-if="item.value == ''">选择的答案：未作答</span>
              </div>
            </div>
            <div class="dispright" style="color: #1b89ce">
              <span></span>
              <span>得分：{{ item.WinScore }}</span>
            </div>
            <div class="analysis" v-if="item.Explain ">
              <div>解析：<span>{{ item.Explain }}</span></div>
              <!-- <el-collapse>
                <el-collapse-item title="答案解析：">
                  <div>
                    <span>{{ item.Explain }}</span>
                  </div>
                </el-collapse-item>
              </el-collapse> -->
            </div>
          </div>
        </div>
        <div class="titles" v-if="ddxt != 0">
          <span style="padding-left: 30px">多选题</span>
          <span style="padding-left: 10px"
            >(共{{ ddxt }}题，合计{{ ddxtSum }}分)</span
          >
        </div>
        <div
          v-for="(item1, index1) in abc"
          :key="index1 + 'f5'"
          v-if="item1.Type == 2"
        >
          <div class="hhh">
            <div class="sss">
              <div class="subject">
                <span>{{ index1 + 1 }}.</span>
                <span v-html="item1.Title" :id="item1.id"></span>
              </div>
              <div>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="取消标记"
                  placement="top"
                >
                  <svg v-if="item1.bjStatus == true" class="icon">
                    <use xlink:href="#iconbiaoji" />
                  </svg>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="标记"
                  placement="top"
                >
                  <svg v-if="item1.bjStatus == false" class="icon">
                    <use xlink:href="#iconmark" />
                  </svg>
                </el-tooltip>
              </div>
            </div>
            <div class="select-box">
              <ul>
                <li
                  v-for="(items, indexs1) in item1.Answer"
                  :key="indexs1 + 'f4'"
                  :id="items.Name"
                >
                  <input
                    type="checkbox"
                    v-model="items.IsCheck"
                    :value="items.Id"
                    disabled
                    style="margin-left: -30px"
                  />
                  {{ String.fromCharCode(64 + parseInt(indexs1 + 1)) }}.
                  <label :for="items.Id" style="font-size: 15px">
                    {{ items.Name }}
                  </label>
                </li>
              </ul>
            </div>
            <!-- v-if="item1.Answer" -->
            <div class="correct" >
            
             <!-- v-if="item1.mycate == ''"  -->
              <span v-if="item1.MyCate == false"><i
                  class="el-icon-warning"
                  style="color: #e6a23c; width: 25px;font-size:18px"
                ></i
                >未作答</span>
             <span v-else>
                <span v-if="item1.IsRight">
                <i
                  class="el-icon-success"
                  style="color: #67c23a;width: 25px;font-size:18px"
                ></i>答对了
              </span>
              <span v-else>
                <i
                  class="el-icon-error"
                  style="color: #f56c6c; width: 25px;font-size:18px"
                ></i>答错了
              </span>
             </span>
            </div>
            <div class="answer">
              <div class="rightanswer">
                <div>正确答案：</div>
                <div
                  v-for="(items, indexs) in item1.Answer"
                  :key="indexs + 'f3'"
                >
                  <span v-if="indexs == 0 && items.IsRight == true">A</span>
                  <span v-if="indexs == 1 && items.IsRight == true">B</span>
                  <span v-if="indexs == 2 && items.IsRight == true">C</span>
                  <span v-if="indexs == 3 && items.IsRight == true">D</span>
                  <span v-if="indexs == 4 && items.IsRight == true">E</span>
                  <span v-if="indexs == 5 && items.IsRight == true">F</span>
                  <span v-if="indexs == 6 && items.IsRight == true">G</span>
                  <span v-if="indexs == 7 && items.IsRight == true">H</span>
                </div>
              </div>
              <div class="mychange">
                <div v-if="item1.MyCate != ''">选择的答案：</div>
                <div
                  v-for="(items, indexs2) in item1.Answer"
                  :key="indexs2 + 'f2'"
                >
                  <span v-if="indexs2 == 0 && items.IsCheck == true">A</span>
                  <span v-if="indexs2 == 1 && items.IsCheck == true">B</span>
                  <span v-if="indexs2 == 2 && items.IsCheck == true">C</span>
                  <span v-if="indexs2 == 3 && items.IsCheck == true">D</span>
                  <span v-if="indexs2 == 4 && items.IsCheck == true">E</span>
                  <span v-if="indexs2 == 5 && items.IsCheck == true">F</span>
                  <span v-if="indexs2 == 6 && items.IsCheck == true">G</span>
                  <span v-if="indexs2 == 7 && items.IsCheck == true">H</span>
                </div>
              </div>
              <div class="mychange" v-if="item1.mycate == false">
                <span>选择的答案：未作答</span>
              </div>
            </div>
            <div class="dispright" style="color: #1b89ce">
              <span></span>
              <span>得分：{{ item1.WinScore }}</span>
            </div>
            <div class="analysis" v-if="item1.Explain ">
              <div>解析：<span>{{ item1.Explain }}</span></div>
           
            </div>
          </div>
        </div>
        <div class="titles" v-if="pdt != 0">
          <span style="padding-left: 30px">判断题</span>
          <span style="padding-left: 10px"
            >(共{{ pdt }}题，合计{{ pdtSum }}分)</span
          >
        </div>
        <div
          v-for="(item, index2) in abc"
          :key="index2 + 'f1'"
          v-if="item.Type == 3"
        >
          <div class="hhh">
            <div class="sss">
              <div class="subject">
                <span>{{ index2 + 1 }}.</span>
                <span v-html="item.Title" :id="item.Id"></span>
              </div>
              <div>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="取消标记"
                  placement="top"
                >
                  <svg v-if="item.bjStatus == true" class="icon">
                    <use xlink:href="#iconbiaoji" />
                  </svg>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="标记"
                  placement="top"
                >
                  <svg v-if="item.bjStatus == false" class="icon">
                    <use xlink:href="#iconmark" />
                  </svg>
                </el-tooltip>
              </div>
            </div>
            <div style="padding-left: 35px; line-height: 50px">
              <input
                v-for="(items, indexs) in item.Answer"
                :checked="items.IsCheck == true"
                :key="indexs + 'a2'"
                :name="item.Id"
                type="radio"
                disabled
              />
              <label style="font-size: 15px">正确</label>
              <input
                v-for="(items, indexs) in item.Answer"
                :checked="items.IsCheck == false"
                :key="indexs + 'a1'"
                :name="item.Id"
                type="radio"
                style="margin-left: 20px"
                disabled
              />
              <label style="font-size: 15px">错误</label>
            </div>
            <!-- v-if="item.Answer" -->
            <div class="correct" >
     

               <span v-if="item.mycate==false" > <i
                  class="el-icon-warning"
                  style="color: #e6a23c; width: 25px;font-size:18px"
                ></i>未作答</span>

              <span v-else>
                <span v-if="item.IsRight==true">
                  <i
                  class="el-icon-success"
                  style="color: #67c23a;width: 25px;font-size:18px"
                ></i>答对了
                </span>
                <span v-else-if="item.IsRight==false">
                  <i
                  class="el-icon-error"
                  style="color: #f56c6c; width: 25px;font-size:18px"
                ></i>答错了
                </span>
              </span>


            </div>
            <div class="answer">
              <div
                v-for="(items, indexs) in item.Answer"
                :key="indexs + 'd6'"
                :id="items.Name"
              >
                <span v-if="items.IsRight == true">正确答案：正确</span>
                <span v-if="items.IsRight == false">正确答案：错误</span>
              </div>
              <div
                v-for="(items, indexs2) in item.Answer"
                :key="indexs2 + 'd5'"
                :id="items.Name"
                style="margin-left: 40px"
              >
                <span v-if="items.IsCheck == true">选择的答案：正确</span>
                <span v-else-if="items.IsCheck == false">选择的答案：错误</span>
                <span v-else>选择的答案：未作答</span>
              </div>
            </div>
            <div class="dispright" style="color: #1b89ce">
              <span></span>
              <span>得分：{{ item.WinScore }}</span>
            </div>
            <div class="analysis" v-if="item.Explain ">
              <div>解析：<span>{{ item.Explain }}</span></div>
              <!-- <el-collapse>
                <el-collapse-item title="答案解析：">
                  <div>
                    <span>{{ item.Explain }}</span>
                  </div>
                </el-collapse-item>
              </el-collapse> -->
            </div>
          </div>
        </div>
        <div class="titles" v-if="tkt != 0">
          <span style="padding-left: 30px">填空题</span>
          <span style="padding-left: 10px"
            >(共{{ tkt }}题，合计{{ tktSum }}分)</span
          >
        </div>
        <div
          v-for="(item, index4) in abc"
          :key="index4 + 'd4'"
          v-if="item.Type == 4"
        >
          <div class="hhh">
            <div class="sss">
              <!-- <div :id="item.Title">{{ index4 + 1 }}.{{ item.Title }}</div> -->
              <div class="subject">
                <span>{{ index4 + 1 }}.</span>
                <span v-html="item.Title" :id="item.Id"></span>
              </div>
              <div>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="取消标记"
                  placement="top"
                >
                  <svg v-if="item.bjStatus == true" class="icon">
                    <use xlink:href="#iconbiaoji" />
                  </svg>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="标记"
                  placement="top"
                >
                  <svg v-if="item.bjStatus == false" class="icon">
                    <use xlink:href="#iconmark" />
                  </svg>
                </el-tooltip>
              </div>
            </div>

            <div>
              <el-input
                v-for="(items, indexs2) in item.Answer"
                :key="indexs2 + 'd1'"
                v-model="items.letter"
                style="
                  width: 95%;
                  padding-left: 30px;
                  padding-top: 10px;
                  padding-bottom: 10px;
                "
              >
                <template slot="prepend">{{ indexs2 + 1 }}</template>
              </el-input>
            </div>
            <div class="correct" >

               <span v-if="item.mycate == false" > <i
                  class="el-icon-warning"
                  style="color: #e6a23c; width: 25px;font-size:18px"
                ></i>未作答</span>
              <span v-else>
                <span v-if="item.IsRight==true">
                  <i
                  class="el-icon-success"
                  style="color: #67c23a;width: 25px;font-size:18px"
                ></i>答对了
                </span>
                <span v-else-if="item.IsRight==false">
                  <i
                  class="el-icon-error"
                  style="color: #f56c6c; width: 25px;font-size:18px"
                ></i>答错了
                </span>
              </span>  

            </div>
            <div class="answer">
              <div
                class="answer-true"
                v-for="(items, indexs) in item.Answer"
                :key="indexs + 'c4'"
                style="width: 100%"
              >
                <p :title="items.Name">正确答案：{{ items.Name }}</p>
              </div>
            </div>
            <div class="dispright" style="color: #1b89ce">
              <span></span>
              <span>得分：{{ item.WinScore }}</span>
            </div>
            <div class="analysis" v-if="item.Explain ">
              <div>解析：<span>{{ item.Explain }}</span></div>
              <!-- <el-collapse>
                <el-collapse-item title="答案解析：">
                  <div>
                    <span>{{ item.Explain }}</span>
                  </div>
                </el-collapse-item>
              </el-collapse> -->
            </div>
          </div>
        </div>
        <div class="titles" v-if="wdt != 0">
          <span style="padding-left: 30px">问答题</span>
          <span style="padding-left: 10px"
            >(共{{ wdt }}题，合计{{ wdtSum }}分)</span
          >
        </div>
        <div
          v-for="(item, index3) in abc"
          :key="index3 + 'c3'"
          v-if="item.Type == 5"
        >
          <div class="hhh">
            <div class="sss">
              <!-- <div :id="item.Title">{{ index3 + 1 }}.{{ item.Title }}</div> -->
              <div class="subject">
                <span>{{ index3 + 1 }}.</span>
                <span v-html="item.Title" :id="item.Id"></span>
              </div>
              <div>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="取消标记"
                  placement="top"
                >
                  <svg v-if="item.bjStatus == true" class="icon">
                    <use xlink:href="#iconbiaoji" />
                  </svg>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="标记"
                  placement="top"
                >
                  <svg v-if="item.bjStatus == false" class="icon">
                    <use xlink:href="#iconmark" />
                  </svg>
                </el-tooltip>
              </div>
            </div>
            <div>
              <el-input
                v-for="(items, indexs2) in item.Answer"
                :key="indexs2 + 'c2'"
                v-model="items.letter"
                type="textarea"
                :rows="4"
                style="
                  width: 95%;
                  padding-left: 30px;
                  padding-top: 10px;
                  padding-bottom: 20px;
                "
              ></el-input>
            </div>


            <div class="answer">
              <div
                v-for="(items, indexs) in item.Answer"
                :key="indexs + 'c1'"
                class="right-key"
              >
                <span :title="items.Name">正确答案：{{ items.Name }}</span>
              </div>
            </div>
            <div class="dispright" style="color: #1b89ce">
              <span></span>
              <span>得分：{{ item.WinScore }}</span>
            </div>
            <div class="analysis" v-if="item.Explain ">
              <div>解析：<span>{{ item.Explain }}</span></div>
              <!-- <el-collapse>
                <el-collapse-item title="答案解析：">
                  <div>
                    <span>{{ item.Explain }}</span>
                  </div>
                </el-collapse-item>
              </el-collapse> -->
            </div>
          </div>
        </div>
        <div class="titles" v-if="sct != 0">
          <span style="padding-left: 30px">实操题</span>
          <span style="padding-left: 10px"
            >(共{{ sct }}题，合计{{ sctSum }}分)</span
          >
        </div>
        <div
          v-for="(item, index6) in abc"
          :key="index6 + 'a6'"
          v-if="item.Type == 6"
        >
          <div class="hhh">
            <div class="sss">
              <div class="subject">
                <span>{{ index6 + 1 }}.</span>
                <span v-html="item.Title" :id="item.Id"></span>
              </div>
            </div>
            <div class="rules-box">
              <el-input
                :value="item.rules"
                placeholder="答题要求："
                type="textarea"
                rows="5"
                style="width: 95%; padding-left: 30px; padding-bottom: 20px"
              >
              </el-input>
            </div>
            <div class="goscExam">
              <el-button
                type="primary"
                v-if="item.fileUrl.length > 0"
                @click="selectShiCao(item)"
                style="width: 300px"
                >查看答题</el-button
              >
              <el-button type="primary" v-else disabled style="width: 300px"
                >未作答</el-button
              >
              <span style="font-size: 14px"
                ><span style="color: red">注意：</span>
                若无法进入实操考试，请确认是否已安装实操考试插件；安转插件请点击下方插件名称
              </span>
              <el-link type="primary" href="/uploadfile/xtaddin_v1.1.rar"
                >xtaddin_v1.1.rar</el-link
              >
            </div>
          </div>
        </div>
      </div>
      <!-- 考试信息区域 -->
      <div class="rightPreview">
          <div style="width: 120px; padding: 0 10px; box-sizing: border-box">
            <div class="xinxi-box">
              <span class="text">学员姓名</span>
              <span class="class-name">{{ reviewName }}</span>
            </div>
            <div class="xinxi-box">
              <span class="text">考试成绩</span>
              <span class="core" v-if="allWinScore < allScore * 0.6"
                >{{ allWinScore }}分</span
              >
              <span class="core-pass" v-if="allWinScore >= allScore * 0.6"
                >{{ allWinScore }}分</span
              >
            </div>
            <!-- <div class="xinxi-box">
              <span class="text">考试状态</span>
              <span class="core-text" v-if="allWinScore < allScore * 0.6"
                >未通过</span
              >
              <span class="core-success" v-if="allWinScore >= allScore * 0.6"
                >通过</span
              >
            </div> -->
            <div class="close">
              <el-button type="primary"  @click="closeJGDialog">关闭</el-button>
            </div>
            <!-- <div class="outpdf">
            <el-button type="primary" @click="getPdf">导出试卷</el-button>
          </div> -->
          </div>
      </div>
    </div>
  </div>
</template>

<script>
// import * as apiAchievement from "@/api/exam/achievement";
import * as apiExam from "@/api/exam/exam";
import { getInfo} from '@/utils/auth';
import {
 GetExamProcess,
  GetDetailLx,
} from '@/api/exam/paper';
export default {
  props: ["examID", "titleExam",'processId'],
  data() {
    return {
      titleinput: "",
      examList: [],
      dialogStatus: "",
      textMap: {
        0: "查看成绩",
      },
      status: true,
      type: null,
      optionSelect: [
        {
          value: 0,
          label: "全部",
        },
        {
          value: 1,
          label: "答对",
        },
        {
          value: 2,
          label: "答错",
        },
      ],
      valueSelect: {
        value: 0,
      },
      pageIndex: 1,
      pageIndex2: 1,
      pageSize: 20,
      pageSize2: 13,
      dataCount: 0,
      dataCount2: 0,
      cxSubject: null,
      cxLevel: null,
      cxcate: null,
      IsCorrect: null,
      IsFB: null,
      IsUpset: false,
      MasterName: [],
      ExaminersTable: [],
      ExaminersTableALL: [],
      inputName: null,
      inputCode: null,
      //数据
      abc: [],
      answer: "",
      dxt: 0,
      dxtSum: 0,
      tkt: 0,
      tktSum: 0,
      pdt: 0,
      pdtSum: 0,
      wdt: 0,
      wdtSum: 0,
      ddxt: 0,
      ddxtSum: 0,
      sct: 0,
      sctSum: 0,
      activeNames: ["1"], //折叠面板
      multipleSelection: [], // 列表checkbox选中的值
      //选中后返回的valueSelect.value
      previewValue: null,
      allWinScore: 0, //总得分
      userId: 0,
      reviewPaperId: 0, //复核试卷id
      processId: 0, //过程id
      yjj: 0, //已交卷
      wjj: 0, //未交卷
      djing: 0, //正在答卷
      htmlTitle: "", //pdf名称
      allScore: 0,
      reviewName: JSON.parse(getInfo('infos')).name,
      examType: 0,
      readUrl: "",
      dialogVisible4: false,
      urlA: "",
      examIds:null,
      ExamDetail:'',
      userName:'',
      deptName:'',

    };
  },

  created() {
    
  
      this.examIds=this.examID
      this.SelectQuestion();
      this.getexam()


    if (this.$store.state.User.tokens) {
      this.userName = JSON.parse(getInfo('infos')).name;
      this.deptName = JSON.parse(getInfo('infos')).deptName;
    }

  },

  methods: {
        //查询考试信息
    getexam() {
      let para = {
        id: this.examIds,
      };
      GetDetailLx(para).then((res) => {
        this.ExamDetail = res.result;
      });
     
    },
    //查看实操题答题情况
    selectShiCao(item) {
      let para = {
        examId: this.examIds,
        questionId: item.Id,
        userId: this.$store.state.User.ids,
      };
      apiExam.getShiCaoReadUrlNew(para).then((res) => {
        this.urlA = res.result;
        window.location.href = this.urlA;
      });
    },
    jump(domId) {
      this.$nextTick(() => {
        const returnEle = document.getElementById(domId);
        if (!!returnEle) {
          returnEle.scrollIntoView(true);
        }
      });
    },
    //关闭结果弹窗
    closeJGDialog() {
      if(!this.$route.query.Ids){
        this.$emit("closeJGDialog");
      }else{
        this.$router.push('/personCenter/iamExam')
      }
      
      
    },
    //查看结果
    SelectQuestion() {
      this.dxt = 0;
      this.tkt = 0;
      this.pdt = 0;
      this.wdt = 0;
      this.ddxt = 0;
      this.sct = 0;
      this.dxtSum = 0;
      this.tktSum = 0;
      this.pdtSum = 0;
      this.wdtSum = 0;
      this.ddxtSum = 0;
      this.sctSum = 0;
      this.allWinScore = 0;
      this.abc = [];
      let para = {
        id:this.processId
      };
      GetExamProcess(para).then((res) => {
 
         let dataList=JSON.parse(res.result.jsons)
        for (let i = 0; i < dataList.length; i++) {
          dataList[i].value=''
          dataList[i].CheckAnswer = [];
          if (dataList[i].Type == 1) {
            this.dxt += 1;
            this.dxtSum += dataList[i].Score;
          } else if (dataList[i].Type == 2) {
            this.ddxt += 1;
            this.ddxtSum +=dataList[i].Score;
          } else if (dataList[i].Type == 3) {
            this.pdt += 1;
            this.pdtSum += dataList[i].Score;
          } else if (dataList[i].Type == 5) {
            this.wdt += 1;
            this.wdtSum += dataList[i].Score;
          } else if (dataList[i].Type == 4) {
            this.tkt += 1;
            this.tktSum += dataList[i].Score;
          } else if (dataList[i].Type == 6) {
            this.sct += 1;
            this.sctSum +=dataList[i].Score;
          }
          this.allScore = Number(
            this.dxtSum +
              this.ddxtSum +
              this.pdtSum +
              this.wdtSum +
              this.tktSum +
              this.sctSum
          );
          this.allWinScore += dataList[i].WinScore;
        }
         

        for (let i = 0; i <dataList.length; i++) {
          for (let j = 0; j < dataList[i].Answer.length; j++) {
            if (dataList[i].Answer[j].IsCheck ) {
              if(dataList[i].Type==1 || dataList[i].Type==2){
                dataList[i].value = dataList[i].Answer[j].Id;
              }
              
            }
          }
      }
      this.abc =dataList;
        // console.log(this.abc )
      });
    },
  },
};
</script>

<style lang="scss" scoped>

.leftPreview {
  position: sticky;
  top: 20px;
  height: 700px;
  border: 1px solid rgb(226, 223, 223);
  border-radius: 5px;
  background-color: white;
  margin-left: 10px;
}
.rightPreview {
  position: sticky;
  top: 20px;
  height: 350px;
  border: 1px solid rgb(226, 223, 223);
  border-radius: 5px;
  background-color: white;
  margin: 0 10px;
}
.zhuti {
  width: 80%;
  background-color: white;
  margin-left: 10px;
  border-bottom: 1px dashed rgb(226, 223, 223);
  border-radius: 5px;
}
.leftdiv {
  width: 210px;
  border-bottom: 1px solid rgb(226, 223, 223);
  margin-left: 20px;
}
.Title2 {
  font-weight: bold;
  height: 40px;
  padding-top: 5px;
  padding-left: 20px;
  font-size: 18px;
  border-left: 1px dashed rgb(226, 223, 223);
  border-right: 1px dashed rgb(226, 223, 223);
  border-bottom: 1px dashed rgb(226, 223, 223);
  border-top: 1px dashed rgb(226, 223, 223);
  background-color: #fafafa;
}
.nr {
  font-size: 10px;
  padding-top: 20px;
  padding-left: 5px;
}
.xinxi-box {
  font-size: 14px;
  padding: 20px 0;
  padding-left: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #dedede;
}
.xinxi-box .core {
  margin-top: 10px;
  font-size: 18px;
  color: red;
  font-weight: 400;
}
.xinxi-box .core-pass {
  margin-top: 10px;
  font-size: 18px;
  color: blue;
  font-weight: 400;
}
.xinxi-box .core-text {
  margin-top: 10px;
  color: red;
  font-weight: 400;
}
.xinxi-box .core-success {
  margin-top: 10px;
  color: blue;
  font-weight: 400;
}
.xinxi-box .selectAll {
  margin-top: 10px;
  color: blue;
  font-weight: 400;
}
.nav-con {
  width: 100%;
  height: 350px;
  border: 1px solid #f1f3f8;
  border-radius: 5px;
  margin-top: 20px;
}
.nav-con-child {
  color: #b2b8bd;
  margin-left: 45%;
  margin-top: 100px;
}
.leftimg {
  margin-left: 80px;
  margin-top: 200px;
}
.Titles {
  height: 55px;
  padding-top: 15px;
  font-size: 20px;
  font-weight: bold;
  font-weight: bold;
  border-left: 1px dashed rgb(226, 223, 223);
  border-right: 1px dashed rgb(226, 223, 223);
  border-bottom: 1px dashed rgb(226, 223, 223);
  border-top: 1px dashed rgb(226, 223, 223);
  background-color: #f2f2f2;

}
li {
  padding-left: 74px;
  padding-right: 30px;
  list-style: none;
  padding-bottom: 15px;
}
.sss {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  margin-left: 20px;
  margin-right: 20px;
}
.hhh {
  border: 1px solid #f2f2f2;
  margin-top: 20px;
  margin-bottom: 20px;
  padding-top: 20px;
  border-radius: 5px;
}
.btfs {
  margin-left: 80px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.test-description {
  width: 50%;
  margin: 0 auto;
  margin-left: 17%;
  margin-top: 00px;
  margin-bottom: 10px;
  line-height: 25px;
  font-size: 15px;
  /* text-indent: 2em; */
}
.aaa {
  height: 20px;
  width: 28px;
  margin-left: 5px;
  margin-top: 15px;
  border-radius: 2px;
  background-color: #1a8cfe;
}
.top {
  height: 20px;
  min-width: 35px;
  margin-left: 5px;
  margin-top: 15px;
  background-color: gray;
  border-radius: 2px;
  text-align: center;
  line-height: 20px;
}
.top-true {
  background-color: #67c23a;
}
.top-false {
  background-color: red;
}
.bottom {
  height: 20px;
  min-width: 35px;
  margin-left: 5px;
  margin-bottom: 5px;
  background-color: #f1f3f8;
  border-radius: 2px;
}
.analysis {
  width: 92%;
  margin-left: 4%;
  line-height: 40px;
}
.Answer {
  display: flex;
  width: 92%;
  margin: 0 40px;
  /* border-top: 1px dashed rgb(226, 223, 223); */
  line-height: 40px;
}
.correct {
  display: flex;
  width: 92%;
  margin-left: 4%;
  border-top: 1px dashed rgb(226, 223, 223);
  line-height: 40px;
  font-size: 16px;
}
.mychange {
  display: flex;
  width: 150px;
}
.rightanswer {
  display: flex;
  width: 150px;
}
.subject {
  display: flex;
  align-items: baseline;
  font-size: 18px;
}
// /deep/.vue-treeselect__control {
//   width: 400px;
// }
// /deep/.vue-treeselect__menu-container {
//   width: 400px;
// }
.right-key {
  /* width: 80%; */
  padding-right: 20px;
}
.dispright {
  padding: 0 80px;
  display: flex;
  justify-content: space-between;
}
.close {
  padding: 10px 20px;
}
.outpdf {
  padding: 10px 10px;
}
.paper-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
}
.allscore-text {
  font-size: 20px;
  font-weight: 600;
  padding: 10px;
}
.class-name {
  margin-top: 10px;
  font-size: 14px;
  color: #1a8cfe;
}
.Title-text-up:hover {
  color: rgb(0, 162, 255);
  text-decoration: underline;
  cursor: pointer;
}
.button-underline:hover {
  color: rgba(0, 162, 255, 0.658);
  text-decoration: underline;
}
.goscExam {
  margin: 10px 20px;
  display: flex;
  flex-direction: column;
  line-height: 40px;
  align-items: center;
}
.rules-box {
  display: flex;
  margin-top: 10px;
}
label {
  font-weight: 400;
}
.select-box {
  margin-top: 20px;
  font-size: 16px;
}
</style>

<style scoped>
.subject >>>p{
  padding: 0;
  margin: 0 !important;
}
</style>